export default __webpack_public_path__ + "src/docs/packages/gau_limp.pdf";